<template>
    <div>
        <block v-if="loading" />

        <!-- Barra de acciones -->
        <v-card flat class="pa-4 bar">
            <div class="d-flex justify-end align-center">
                <v-btn small class="btn-save mr-1" @click="generateAndSave">
                    GENERAR
                </v-btn>
            </div>
        </v-card>

        <!-- Filtros -->
        <v-row class="mt-2">
            <v-col cols="12" md="5">
                <v-select
                    v-model="search.month"
                    :items="monthList"
                    item-text="monthName"
                    item-value="monthIndex"
                    label="Mes"
                    outlined
                    attach
                    dense
                ></v-select>
            </v-col>
            <v-col cols="12" md="5">
                <v-text-field
                    v-model="search.year"
                    label="Año"
                    outlined
                    attach
                    dense
                    type="number"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="d-flex align-center">
                <v-radio-group v-model="dataType" row class="mt-0">
                    <v-radio label="Prueba" value="00"></v-radio>
                    <v-radio label="Producción" value="01"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
        <hr/>

        <!-- TABS -->
        <v-tabs v-model="activeTab" class="mt-3" background-color="white" color="primary">
            <v-tab>LISTADO DE PERÍODOS</v-tab>
            <v-tab :disabled="!selectedRecord">DECLARACIÓN IVA</v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">
            <!-- ===== TAB 1: LISTADO ===== -->
            <v-tab-item class="row">
                <div class="col-12 mt-2">
                    <div class="period-table-scroll">
                        <v-simple-table class="elevation-1 period-table">
                            <template #default>
                                <thead>
                                    <tr>
                                        <th rowspan="2">MES</th>
                                        <th rowspan="2">AÑO</th>
                                        <th rowspan="2">FECHA GENERADO</th>
                                        <th colspan="8" class="text-center">DECLARACION DE IVA</th>
                                        <th colspan="6" class="text-center">DECLARACION DE PAGO A CUENTA</th>
                                        <th colspan="10" class="text-center">DECLARACION DE RENTA</th>
                                        <th rowspan="2" class="text-center">ESTADO</th>
                                        <th rowspan="2" class="text-center">ACCIONES</th>
                                    </tr>
                                    <tr>
                                        <th class="text-right">DÉBITO FISCAL</th>
                                        <th class="text-right">CRÉDITO FISCAL</th>
                                        <th class="text-right">DIFERENCIA IVA</th>
                                        <th class="text-right">REMANENTE ANT.</th>
                                        <th class="text-right">SALDO ACUM. ANT.</th>
                                        <th class="text-right">IVA A PAGAR</th>
                                        <th class="text-right">IVA PAGADO</th>
                                        <th class="text-right">SALDO IVA</th>
                                        <th class="text-right">INGRESOS CON RET.</th>
                                        <th class="text-right">INGRESOS SIN RET.</th>
                                        <th class="text-right">REMANENTE ANT.</th>
                                        <th class="text-right">PAGO / REM. SIG.</th>
                                        <th class="text-right">PAGADO</th>
                                        <th class="text-right">SALDO</th>
                                        <th class="text-right">CON DEP.</th>
                                        <th class="text-right">SIN DEP. CANT.</th>
                                        <th class="text-right">SIN DEP. MONTO</th>
                                        <th class="text-right">ALQ. CANT.</th>
                                        <th class="text-right">ALQ. MONTO</th>
                                        <th class="text-right">SUJ. EXCL. CANT.</th>
                                        <th class="text-right">SUJ. EXCL. MONTO</th>
                                        <th class="text-right">TOTAL RET.</th>
                                        <th class="text-right">PAGADO</th>
                                        <th class="text-right">SALDO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="allRecords.length === 0">
                                        <td colspan="29" class="text-center grey--text py-4">No hay registros guardados</td>
                                    </tr>
                                    <tr
                                        v-for="rec in allRecords"
                                        :key="rec.ID"
                                        :class="selectedRecord && selectedRecord.ID === rec.ID ? 'selected-row' : ''"
                                        style="cursor:pointer"
                                        @click="openRecord(rec)"
                                    >
                                        <td>{{ monthName(rec.PeriodMonth) }}</td>
                                        <td>{{ rec.PeriodYear }}</td>
                                        <td>{{ formatDate(rec.SystemDateInsert) }}</td>
                                        <td class="text-right">{{ fmt(rec.DebitoFiscal) }}</td>
                                        <td class="text-right">{{ fmt(rec.CreditoFiscal) }}</td>
                                        <td class="text-right" :class="rec.DiferenciaIVA < 0 ? 'red--text' : ''">{{ fmt(rec.DiferenciaIVA) }}</td>
                                        <td class="text-right">{{ fmt(rec.RemanentePeriodoAnterior) }}</td>
                                        <td class="text-right">{{ fmt(rec.SaldoAcumuladoAnterior) }}</td>
                                        <td class="text-right">{{ fmt(rec.IvaAPagar) }}</td>
                                        <td class="text-right success--text">{{ fmt(rec.IvaPagado) }}</td>
                                        <td class="text-right" :class="(rec.SaldoPendiente || 0) < 0 ? 'primary--text font-weight-bold' : (rec.SaldoPendiente || 0) > 0 ? 'red--text font-weight-bold' : ''">{{ fmt(rec.SaldoPendiente) }}</td>
                                        <td class="text-right">{{ fmt(rec.PagoCuentaIngresosConRetencion) }}</td>
                                        <td class="text-right">{{ fmt(rec.PagoCuentaIngresosSinRetencion) }}</td>
                                        <td class="text-right">{{ fmt(rec.PagoCuentaRemanentePeriodoAnterior) }}</td>
                                        <td class="text-right">{{ fmt(rec.PagoCuentaRemanenteSiguientePeriodo) }}</td>
                                        <td class="text-right success--text">{{ fmt(rec.PagoCuentaPagado) }}</td>
                                        <td class="text-right" :class="(rec.PagoCuentaSaldoPendiente || 0) > 0 ? 'red--text font-weight-bold' : ''">{{ fmt(rec.PagoCuentaSaldoPendiente) }}</td>
                                        <td class="text-right">{{ fmt(rec.RentaRetencionesConDependenciaLaboral) }}</td>
                                        <td class="text-right">{{ rec.RentaRetencionesSinDependenciaLaboralCantidad || 0 }}</td>
                                        <td class="text-right">{{ fmt(rec.RentaRetencionesSinDependenciaLaboralMonto) }}</td>
                                        <td class="text-right">{{ rec.RentaRetencionesPorAlquilerCantidad || 0 }}</td>
                                        <td class="text-right">{{ fmt(rec.RentaRetencionesPorAlquilerMonto) }}</td>
                                        <td class="text-right">{{ rec.SujetosExcluidosCantidad || 0 }}</td>
                                        <td class="text-right">{{ fmt(rec.SujetosExcluidosRenta) }}</td>
                                        <td class="text-right">{{ fmt(rec.RentaTotalAPagarRetenciones) }}</td>
                                        <td class="text-right success--text">{{ fmt(rec.RentaPagada) }}</td>
                                        <td class="text-right" :class="(rec.RentaSaldoPendiente || 0) > 0 ? 'red--text font-weight-bold' : ''">{{ fmt(rec.RentaSaldoPendiente) }}</td>
                                        <td class="text-center">
                                            <v-chip x-small :color="rec.Status === 1 ? 'success' : 'warning'" dark>
                                                {{ rec.Status === 1 ? 'Procesado' : 'Pendiente' }}
                                            </v-chip>
                                        </td>
                                        <td class="text-center" @click.stop>
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-btn icon small v-on="on" @click="exportExcel(rec)">
                                                        <v-icon small :color="rec.Status === 1 ? 'success' : 'grey'">mdi-microsoft-excel</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ rec.Status === 1 ? 'Descargar Excel' : 'Solo disponible cuando está Procesado' }}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-btn icon small v-on="on"
                                                        :disabled="rec.Status === 1"
                                                        @click="openRecord(rec)">
                                                        <v-icon small :color="rec.Status !== 1 ? 'primary' : 'grey'">mdi-pencil</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ rec.Status !== 1 ? 'Editar declaración' : 'Período ya procesado' }}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-btn icon small v-on="on"
                                                        @click="confirmDelete(rec)">
                                                        <v-icon small color="error">mdi-delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Eliminar</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>
                </div>
            </v-tab-item>

            <!-- ===== TAB 2: DECLARACIÓN IVA (editable) ===== -->
            <v-tab-item>
                <v-card v-if="selectedRecord" flat class="pa-4 mt-2">
                    <!-- Encabezado -->
                    <div class="decl-header mb-4">
                        <div class="decl-title">{{ businessName }}</div>
                        <div class="decl-subtitle">DECLARACIÓN DE IVA — {{ monthName(selectedRecord.PeriodMonth) }} {{ selectedRecord.PeriodYear }}</div>
                        <v-chip class="mt-1" small :color="selectedRecord.Status === 1 ? 'success' : 'warning'" dark>
                            {{ selectedRecord.Status === 1 ? 'Procesado' : 'Pendiente' }}
                        </v-chip>
                    </div>

                    <!-- Formulario con mismo orden que Excel -->
                    <div class="decl-panels">
                        <section class="decl-panel">
                            <div class="decl-panel__title">DECLARACIÓN IVA</div>
                            <div class="tax-table">
                                <div class="section-header">
                                    <span>COMPRAS</span>
                                    <span class="section-header__column">IVA</span>
                                    <span class="section-header__column">Monto</span>
                                </div>
                                <div class="tax-row">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Compras gravadas</div>
                                    <div class="tax-cell" data-label="IVA">
                                        <v-text-field v-model.number="editForm.CreditoFiscal"
                                            aria-label="Crédito Fiscal IVA compras" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.ComprasGravadas"
                                            aria-label="Compras gravadas" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Compras exentas</div>
                                    <div class="tax-cell tax-cell--empty" data-label="IVA"></div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.ComprasExentas"
                                            aria-label="Compras exentas" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Menos: Retención IVA 2%</div>
                                    <div class="tax-cell tax-cell--empty" data-label="IVA"></div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.IvaRetencionCompras2"
                                            aria-label="Menos retención IVA 2% compras" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Menos: Percepción IVA 1%</div>
                                    <div class="tax-cell tax-cell--empty" data-label="IVA"></div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.IvaPercepcionCompras1"
                                            aria-label="Menos percepción IVA 1% compras" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        Total Compras
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell tax-cell--empty" data-label="IVA"></div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(editForm.TotalCompras)"
                                            aria-label="Total Compras" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>

                                <div class="section-header">
                                    <span>VENTAS</span>
                                    <span class="section-header__column">IVA</span>
                                    <span class="section-header__column">Monto</span>
                                </div>
                                <div class="tax-row">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Gravado local Consumidor Final</div>
                                    <div class="tax-cell" data-label="IVA">
                                        <v-text-field v-model.number="editForm.DebitoFiscalConsumidorFinal"
                                            aria-label="IVA gravado local consumidor final" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.VentasGravadasLocalesConsumidorFinal"
                                            aria-label="Monto gravado local consumidor final" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Gravado local Crédito fiscal</div>
                                    <div class="tax-cell" data-label="IVA">
                                        <v-text-field v-model.number="editForm.DebitoFiscalCreditoFiscal"
                                            aria-label="IVA gravado local crédito fiscal" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.VentasGravadasLocalesCreditoFiscal"
                                            aria-label="Monto gravado local crédito fiscal" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Ventas exentas</div>
                                    <div class="tax-cell tax-cell--empty" data-label="IVA"></div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.VentasExentas"
                                            aria-label="Ventas exentas" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Ventas no sujetas</div>
                                    <div class="tax-cell tax-cell--empty" data-label="IVA"></div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.VentasNoSujetas"
                                            aria-label="Ventas no sujetas" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Menos: Retención IVA 1%</div>
                                    <div class="tax-cell tax-cell--empty" data-label="IVA"></div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.IvaRetencionVentas1"
                                            aria-label="Menos retención IVA 1% ventas" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        Total Ventas
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell tax-cell--empty" data-label="IVA"></div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(editForm.TotalVentas)"
                                            aria-label="Total Ventas" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>

                                <div class="section-header section-header--single-value">
                                    <span>RESULTADO IVA</span>
                                    <span class="section-header__column">Monto</span>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        Diferencia IVA (Débito - Crédito)
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(editForm.DiferenciaIVA)"
                                            aria-label="Diferencia IVA Débito menos Crédito" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Remanente período anterior</div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.RemanentePeriodoAnterior"
                                            aria-label="Remanente período anterior" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Menos: Retención IVA 1%</div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(editForm.IvaRetencionVentas1)"
                                            aria-label="Menos retención IVA 1% resultado" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Menos: Retención IVA 2%</div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(editForm.IvaRetencionCompras2)"
                                            aria-label="Menos retención IVA 2% resultado" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Menos: Percepción IVA 1%</div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(editForm.IvaPercepcionCompras1)"
                                            aria-label="Menos percepción IVA 1% resultado" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        IVA por pagar / Remanente
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(ivaNeto)"
                                            aria-label="IVA por pagar o Remanente" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value" v-if="false">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        Remanente para próximo período
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(remProximo)"
                                            aria-label="Remanente para próximo período" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value" style="display: none;">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        IVA a pagar
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(ivaPagar)"
                                            aria-label="IVA a pagar" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>

                                <div class="section-header section-header--single-value">
                                    <span>PAGO IVA</span>
                                    <span class="section-header__column">Monto</span>
                                </div>
                                <div class="tax-row tax-row--single-value" v-if="editForm.SaldoAcumuladoAnterior > 0">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        Deuda arrastrada de períodos anteriores
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(editForm.SaldoAcumuladoAnterior)"
                                            aria-label="Deuda arrastrada de períodos anteriores" prefix="$" outlined dense readonly
                                            hint="Saldo pendiente acumulado de meses anteriores"
                                            persistent-hint />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        IVA a pagar
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(ivaPagar)"
                                            aria-label="IVA a pagar pago IVA" prefix="$" outlined dense readonly
                                            :hint="ivaPagar <= 0 ? 'Período con remanente - crédito a favor' : ''"
                                            persistent-hint />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Monto pagado</div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.IvaPagado"
                                            aria-label="Monto pagado" prefix="$" type="number" outlined dense
                                            :readonly="selectedRecord.Status === 1 || ivaPagar <= 0"
                                            :hint="ivaPagar <= 0 ? 'No hay IVA a pagar este período' : 'Puede ser un pago parcial'"
                                            persistent-hint>
                                            <template #prepend-inner>
                                                <v-tooltip bottom>
                                                    <template #activator="{ on }">
                                                        <v-btn icon x-small class="payment-fill-btn"
                                                            :disabled="selectedRecord.Status === 1 || ivaPagar <= 0"
                                                            v-on="on"
                                                            @click.stop="fillFullPayment('IvaPagado', ivaPagar)">
                                                            <v-icon small>mdi-cash-multiple</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Llenar monto completo</span>
                                                </v-tooltip>
                                            </template>
                                        </v-text-field>
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        Remanente para próximo periodo
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(saldoPendiente)"
                                            aria-label="Remanente para próximo periodo" prefix="$" outlined dense readonly
                                            :hint="saldoPendiente < 0 ? 'Saldo a favor' : (saldoPendiente > 0 ? 'Saldo pendiente por pagar' : 'Sin saldo pendiente')"
                                            persistent-hint />
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="decl-panel">
                            <div class="decl-panel__title">DECLARACIÓN DE PAGO A CUENTA</div>
                            <div class="tax-table">
                                <div class="section-header section-header--single-value">
                                    <span>PAGO A CUENTA</span>
                                    <span class="section-header__column">Monto</span>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Ingresos con retención pago a cuenta</div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.PagoCuentaIngresosConRetencion"
                                            aria-label="Ingresos con retención pago a cuenta" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        Ingresos sin retención pago a cuenta
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-btn icon x-small class="calculated-icon-btn"
                                                    :disabled="selectedRecord.Status === 1"
                                                    v-on="on"
                                                    @click.stop="recalcularPagoCuentaIngresosSinRetencion">
                                                    <v-icon small class="calculated-icon">mdi-calculator</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Recalcular automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.PagoCuentaIngresosSinRetencion"
                                            aria-label="Ingresos sin retención pago a cuenta" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        Pago a cuenta calculado (1.75%)
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(pagoCuentaCalculado)"
                                            aria-label="Pago a cuenta calculado 1.75%" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Remanente período anterior pago a cuenta</div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.PagoCuentaRemanentePeriodoAnterior"
                                            aria-label="Remanente período anterior pago a cuenta" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        Pago / remanente siguiente período
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(pagoCuentaRemanenteSiguientePeriodo)"
                                            aria-label="Pago o remanente siguiente período" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Monto pagado</div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.PagoCuentaPagado"
                                            aria-label="Monto pagado pago a cuenta" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1 || pagoCuentaAPagar <= 0">
                                            <template #prepend-inner>
                                                <v-tooltip bottom>
                                                    <template #activator="{ on }">
                                                        <v-btn icon x-small class="payment-fill-btn"
                                                            :disabled="selectedRecord.Status === 1 || pagoCuentaAPagar <= 0"
                                                            v-on="on"
                                                            @click.stop="fillFullPayment('PagoCuentaPagado', pagoCuentaAPagar)">
                                                            <v-icon small>mdi-cash-multiple</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Llenar monto completo</span>
                                                </v-tooltip>
                                            </template>
                                        </v-text-field>
                                    </div>
                                </div>
                                <div class="tax-row tax-row--single-value">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        Saldo pendiente
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field :value="fmt(pagoCuentaSaldoPendiente)"
                                            aria-label="Saldo pendiente pago a cuenta" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>

                                <div class="section-header section-header--renta">
                                    <span>RETENCIONES DE RENTA</span>
                                    <span class="section-header__column">Cantidad</span>
                                    <span class="section-header__column">Monto</span>
                                    <span class="section-header__column">Renta</span>
                                </div>
                                <div class="tax-row tax-row--renta">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Retenciones con dependencia laboral</div>
                                    <div class="tax-cell tax-cell--empty" data-label="Cantidad"></div>
                                    <div class="tax-cell tax-cell--empty" data-label="Monto"></div>
                                    <div class="tax-cell" data-label="Renta">
                                        <v-text-field v-model.number="editForm.RentaRetencionesConDependenciaLaboral"
                                            aria-label="Retenciones con dependencia laboral" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1 || !allowedEditing" />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--renta">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Sin dependencia laboral</div>
                                    <div class="tax-cell" data-label="Cantidad">
                                        <v-text-field v-model.number="editForm.RentaRetencionesSinDependenciaLaboralCantidad"
                                            aria-label="Cantidad sin dependencia laboral" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1 || !allowedEditing" />
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.RentaRetencionesSinDependenciaLaboralMonto"
                                            aria-label="Monto sin dependencia laboral" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1 || !allowedEditing" />
                                    </div>
                                    <div class="tax-cell tax-cell--with-icon" data-label="Renta">
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                        <v-text-field :value="fmt(rentaRetencionSinDependenciaCalculada)"
                                            aria-label="Renta sin dependencia laboral 10%" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--renta">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Por alquiler</div>
                                    <div class="tax-cell" data-label="Cantidad">
                                        <v-text-field v-model.number="editForm.RentaRetencionesPorAlquilerCantidad"
                                            aria-label="Cantidad por alquiler" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1 || !allowedEditing" />
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.RentaRetencionesPorAlquilerMonto"
                                            aria-label="Monto por alquiler" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1 || !allowedEditing" />
                                    </div>
                                    <div class="tax-cell tax-cell--with-icon" data-label="Renta">
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                        <v-text-field :value="fmt(rentaRetencionPorAlquilerCalculada)"
                                            aria-label="Renta por alquiler 10%" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--renta">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Sujetos excluidos</div>
                                    <div class="tax-cell" data-label="Cantidad">
                                        <v-text-field v-model.number="editForm.SujetosExcluidosCantidad"
                                            aria-label="Cantidad sujetos excluidos" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                    <div class="tax-cell" data-label="Monto">
                                        <v-text-field v-model.number="editForm.SujetosExcluidosMonto"
                                            aria-label="Monto sujetos excluidos" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                    <div class="tax-cell" data-label="Renta">
                                        <v-text-field v-model.number="editForm.SujetosExcluidosRenta"
                                            aria-label="Renta sujetos excluidos" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--renta">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Remanente período anterior renta</div>
                                    <div class="tax-cell tax-cell--empty" data-label="Cantidad"></div>
                                    <div class="tax-cell tax-cell--empty" data-label="Monto"></div>
                                    <div class="tax-cell" data-label="Renta">
                                        <v-text-field v-model.number="editForm.RentaRemanentePeriodoAnterior"
                                            aria-label="Remanente período anterior renta" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1" />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--renta">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        Total a pagar retenciones
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell tax-cell--empty" data-label="Cantidad"></div>
                                    <div class="tax-cell tax-cell--empty" data-label="Monto"></div>
                                    <div class="tax-cell" data-label="Renta">
                                        <v-text-field :value="fmt(rentaTotalRetenciones)"
                                            aria-label="Total a pagar retenciones" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>
                                <div class="tax-row tax-row--renta">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">Monto pagado</div>
                                    <div class="tax-cell tax-cell--empty" data-label="Cantidad"></div>
                                    <div class="tax-cell tax-cell--empty" data-label="Monto"></div>
                                    <div class="tax-cell" data-label="Renta">
                                        <v-text-field v-model.number="editForm.RentaPagada"
                                            aria-label="Monto pagado retenciones" prefix="$" type="number" outlined dense hide-details
                                            :readonly="selectedRecord.Status === 1 || rentaTotalRetenciones <= 0">
                                            <template #prepend-inner>
                                                <v-tooltip bottom>
                                                    <template #activator="{ on }">
                                                        <v-btn icon x-small class="payment-fill-btn"
                                                            :disabled="selectedRecord.Status === 1 || rentaTotalRetenciones <= 0"
                                                            v-on="on"
                                                            @click.stop="fillFullPayment('RentaPagada', rentaTotalRetenciones)">
                                                            <v-icon small>mdi-cash-multiple</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Llenar monto completo</span>
                                                </v-tooltip>
                                            </template>
                                        </v-text-field>
                                    </div>
                                </div>
                                <div class="tax-row tax-row--renta">
                                    <div class="tax-cell tax-cell--description" data-label="Descripción">
                                        Saldo pendiente
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon small class="calculated-icon" v-on="on">mdi-calculator</v-icon>
                                            </template>
                                            <span>Campo calculado automáticamente</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="tax-cell tax-cell--empty" data-label="Cantidad"></div>
                                    <div class="tax-cell tax-cell--empty" data-label="Monto"></div>
                                    <div class="tax-cell" data-label="Renta">
                                        <v-text-field :value="fmt(rentaSaldoPendiente)"
                                            aria-label="Saldo pendiente retenciones" prefix="$" outlined dense hide-details readonly />
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    <v-card flat class="stats-card mt-5">
                        <div class="stats-card__title">RESUMEN DE IMPUESTO</div>
                        <v-row>
                            <v-col cols="12" sm="6" md="3">
                                <div class="stat-box">
                                    <div class="stat-box__label">IVA</div>
                                    <div class="stat-box__value">{{ fmt(ivaPagar) }}</div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <div class="stat-box">
                                    <div class="stat-box__label">Pago a cuenta</div>
                                    <div class="stat-box__value">{{ fmt(pagoCuentaAPagar) }}</div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <div class="stat-box">
                                    <div class="stat-box__label">Retenciones</div>
                                    <div class="stat-box__value">{{ fmt(rentaTotalRetenciones) }}</div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <div class="stat-box stat-box--accent">
                                    <div class="stat-box__label">Total a pagar en mandamientos</div>
                                    <div class="stat-box__value">{{ fmt(totalAPagarMandamientos) }}</div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <div class="stat-box">
                                    <div class="stat-box__label">Total pagado</div>
                                    <div class="stat-box__value">{{ fmt(totalPagadoMandamientos) }}</div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <div class="stat-box">
                                    <div class="stat-box__label">Saldo pendiente total</div>
                                    <div class="stat-box__value">{{ fmt(totalSaldoPendienteMandamientos) }}</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>

                    <v-row class="mt-1">
                        <!-- Botón registrar pago (oculto temporalmente) -->
                        <v-col cols="12" class="d-flex justify-end" v-if="false">
                            <v-btn small class="btn-save" @click="savePayment">
                                <v-icon small left>mdi-cash-check</v-icon> REGISTRAR PAGO
                            </v-btn>
                        </v-col>

                        <!-- Botones declaración -->
                        <v-col cols="12" class="d-flex justify-end gap-2" v-if="selectedRecord.Status !== 1">
                            <v-btn class="btn-save mr-2" small @click="saveEdit">
                                <v-icon small left>mdi-content-save</v-icon> GUARDAR CAMBIOS
                            </v-btn>
                            <v-btn class="btn-save" small @click="confirmProcesar">
                                <v-icon small left>mdi-check-circle</v-icon> GUARDAR COMO PROCESADO
                            </v-btn>
                        </v-col>
                        <v-col cols="12" class="d-flex justify-end" v-else>
                            <v-btn class="btn-save" small @click="exportExcel(selectedRecord)">
                                <v-icon small left>mdi-microsoft-excel</v-icon> DESCARGAR EXCEL
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-tab-item>
        </v-tabs-items>

        <alerts
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            :properties="alert"
        ></alerts>
    </div>
</template>

<script>
    import Alerts from '@/components/Alerts.vue';
    import Block from '@/components/Block.vue';
    import ExcelJS from 'exceljs';
    import { saveAs } from 'file-saver';

    const MONTH_NAMES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
    const DECLARACION_PAGO_CUENTA_DEFAULTS = {
        PagoCuentaIngresosConRetencion: 0,
        PagoCuentaIngresosSinRetencion: 0,
        PagoCuentaRemanentePeriodoAnterior: 0,
        PagoCuentaRemanenteSiguientePeriodo: 0,
        PagoCuentaPagado: 0,
        PagoCuentaSaldoPendiente: 0,
        VentasGravadasLocalesConsumidorFinal: 0,
        DebitoFiscalConsumidorFinal: 0,
        VentasGravadasLocalesCreditoFiscal: 0,
        DebitoFiscalCreditoFiscal: 0,
        IvaRetencionVentas1: 0,
        IvaRetencionCompras2: 0,
        IvaPercepcionCompras1: 0,
        RentaRetencionesConDependenciaLaboral: 0,
        RentaRetencionesSinDependenciaLaboralCantidad: 0,
        RentaRetencionesSinDependenciaLaboralMonto: 0,
        RentaRetencionesPorAlquilerCantidad: 0,
        RentaRetencionesPorAlquilerMonto: 0,
        RentaRemanentePeriodoAnterior: 0,
        SujetosExcluidosCantidad: 0,
        SujetosExcluidosMonto: 0,
        SujetosExcluidosRenta: 0,
        RentaPagada: 0,
        RentaSaldoPendiente: 0,
        RentaTotalAPagarRetenciones: 0,
        TotalAPagarMandamientos: 0,
        TotalPagadoMandamientos: 0,
        TotalSaldoPendienteMandamientos: 0,
    };

    export default {
        name: "TotalsSalesPurchasesReport",
        components: { Alerts, Block },
        props: ['win'],
        data() {
            const currentYear = new Date().getFullYear();
            return {
                loading: false,
                allRecords: [],   // todos los registros (sin filtro de mes)
                records: [],      // filtrados por mes/año seleccionado
                activeTab: 0,
                selectedRecord: null,
                editForm: { ...DECLARACION_PAGO_CUENTA_DEFAULTS },
                businessName: '',
                dataType: '01',
                TipoPlan: '',
                search: { month: new Date().getMonth() + 1, year: currentYear },
                monthList: MONTH_NAMES.map((monthName, index) => ({
                    monthName,
                    monthIndex: index + 1,
                })),
                decFormat: { type: 'fixedPoint', precision: 2 },
                pendingDelete: null,
                pendingGenerateRow: null,
                pendingOverwriteRow: null,
                pendingProcesar: false,
                alert: { type: 'success', show: false, header: '', body: '', options: null },
            };
        },
        computed: {
            ivaNeto() {
                return this.round2(
                    this.toNumber(this.editForm.DiferenciaIVA) -
                    this.toNumber(this.editForm.RemanentePeriodoAnterior) -
                    this.ivaRetencionTotal
                );
            },
            ivaRetencionTotal() {
                return this.round2(
                    this.toNumber(this.editForm.IvaRetencionVentas1) +
                    this.toNumber(this.editForm.IvaRetencionCompras2) +
                    this.toNumber(this.editForm.IvaPercepcionCompras1)
                );
            },
            remProximo() {
                const total = this.round2(this.ivaNeto + this.toNumber(this.editForm.SaldoAcumuladoAnterior));
                return total < 0 ? this.round2(Math.abs(total)) : 0;
            },
            ivaPagar() {
                const total = this.round2(this.ivaNeto + this.toNumber(this.editForm.SaldoAcumuladoAnterior));
                return total > 0 ? total : 0;
            },
            saldoPendiente() {
                const base = this.round2(this.ivaNeto + this.toNumber(this.editForm.SaldoAcumuladoAnterior));
                if (base < 0) {
                    return base;
                }
                return this.round2(Math.max(0, this.ivaPagar - this.toNumber(this.editForm.IvaPagado)));
            },
            pagoCuentaCalculado() {
                return this.round2(this.toNumber(this.editForm.PagoCuentaIngresosSinRetencion) * 0.0175);
            },
            pagoCuentaAPagar() {
                return this.round2(Math.max(0, this.pagoCuentaRemanenteSiguientePeriodo));
            },
            pagoCuentaSaldoPendiente() {
                return this.round2(Math.max(0, this.pagoCuentaAPagar - this.toNumber(this.editForm.PagoCuentaPagado)));
            },
            pagoCuentaRemanenteSiguientePeriodo() {
                return this.round2(this.pagoCuentaCalculado + this.toNumber(this.editForm.PagoCuentaRemanentePeriodoAnterior));
            },
            rentaRetencionSinDependenciaCalculada() {
                return this.round2(this.toNumber(this.editForm.RentaRetencionesSinDependenciaLaboralMonto) * 0.10);
            },
            rentaRetencionPorAlquilerCalculada() {
                return this.round2(this.toNumber(this.editForm.RentaRetencionesPorAlquilerMonto) * 0.10);
            },
            rentaPagada() {
                return this.round2(this.toNumber(this.editForm.RentaPagada));
            },
            rentaSaldoPendiente() {
                return this.round2(Math.max(0, this.rentaTotalRetenciones - this.rentaPagada));
            },
            rentaTotalRetenciones() {
                return this.round2(Math.max(
                    0,
                    this.toNumber(this.editForm.RentaRetencionesConDependenciaLaboral) +
                    this.rentaRetencionSinDependenciaCalculada +
                    this.rentaRetencionPorAlquilerCalculada +
                    this.toNumber(this.editForm.SujetosExcluidosRenta) -
                    this.toNumber(this.editForm.RentaRemanentePeriodoAnterior)
                ));
            },
            totalAPagarMandamientos() {
                return this.round2(this.ivaPagar + this.pagoCuentaAPagar + this.rentaTotalRetenciones);
            },
            totalPagadoMandamientos() {
                return this.round2(this.toNumber(this.editForm.IvaPagado) + this.toNumber(this.editForm.PagoCuentaPagado) + this.rentaPagada);
            },
            totalSaldoPendienteMandamientos() {
                return this.round2(Math.max(0, this.totalAPagarMandamientos - this.totalPagadoMandamientos));
            },
            allowedEditing() {
                return !['Emprendedor', 'Ecoanual'].includes(this.TipoPlan || '');
            },
        },
        watch: {
            'search.month'() { this.loadRecords(); },
            'search.year'() { this.loadRecords(); },
            // Recalcular totales al editar campos clave
            'editForm.ComprasGravadas'()        { this._recalcTotals(); },
            'editForm.ComprasExentas'()         { this._recalcTotals(); },
            'editForm.CreditoFiscal'()          { this._recalcTotals(); },
            'editForm.VentasGravadasLocales'()  { this._recalcTotals(); },
            'editForm.VentasExentas'()          { this._recalcTotals(); },
            'editForm.VentasNoSujetas'()        { this._recalcTotals(); },
            'editForm.DebitoFiscal'()           { this._recalcTotals(); },
            'editForm.VentasGravadasLocalesConsumidorFinal'() { this._recalcVentasGravadasLocalesDetalle(); },
            'editForm.DebitoFiscalConsumidorFinal'()          { this._recalcVentasGravadasLocalesDetalle(); },
            'editForm.VentasGravadasLocalesCreditoFiscal'()   { this._recalcVentasGravadasLocalesDetalle(); },
            'editForm.DebitoFiscalCreditoFiscal'()            { this._recalcVentasGravadasLocalesDetalle(); },
            'editForm.PagoCuentaIngresosConRetencion'()       { this.recalcularPagoCuentaIngresosSinRetencion(); },
        },
        async mounted() {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            this.businessName = (user.business || 'EMPRESA').toUpperCase();
            this.TipoPlan = user.TipoPlan || '';
            await this.loadRecords();
        },
        methods: {
            toNumber(value) {
                return parseFloat(value) || 0;
            },
            round2(value) {
                return Math.round((this.toNumber(value) + Number.EPSILON) * 100) / 100;
            },
            toInt(value) {
                return parseInt(value, 10) || 0;
            },
            fmt(v) {
                const n = this.toNumber(v);
                return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            monthName(m) {
                return MONTH_NAMES[(m || 1) - 1];
            },
            formatDate(d) {
                if (!d) return '';
                return new Date(d).toLocaleDateString('es-SV');
            },
            _recalcTotals() {
                const f = this.editForm;
                this.$set(this.editForm, 'TotalCompras',
                    this.round2(this.toNumber(f.ComprasGravadas) + this.toNumber(f.ComprasExentas)));
                this.$set(this.editForm, 'TotalVentas',
                    this.round2(
                        this.toNumber(f.VentasGravadasLocales) +
                        this.toNumber(f.VentasExentas) +
                        this.toNumber(f.VentasNoSujetas)
                    ));
                this.$set(this.editForm, 'DiferenciaIVA',
                    this.round2(this.toNumber(f.DebitoFiscal) - this.toNumber(f.CreditoFiscal)));
            },
            _recalcVentasGravadasLocalesDetalle() {
                const f = this.editForm;
                const montoDetalle = this.round2(
                    this.toNumber(f.VentasGravadasLocalesConsumidorFinal) +
                    this.toNumber(f.VentasGravadasLocalesCreditoFiscal)
                );
                const ivaDetalle = this.round2(
                    this.toNumber(f.DebitoFiscalConsumidorFinal) +
                    this.toNumber(f.DebitoFiscalCreditoFiscal)
                );

                this.$set(this.editForm, 'VentasGravadasLocales', montoDetalle);
                this.$set(this.editForm, 'DebitoFiscal', ivaDetalle);
            },
            calcularPagoCuentaIngresosSinRetencion(source = this.editForm) {
                return this.round2(
                    this.toNumber(source.TotalVentas) - this.toNumber(source.PagoCuentaIngresosConRetencion)
                );
            },
            recalcularPagoCuentaIngresosSinRetencion() {
                if (!this.selectedRecord || this.selectedRecord.Status === 1) return;
                this.$set(
                    this.editForm,
                    'PagoCuentaIngresosSinRetencion',
                    this.calcularPagoCuentaIngresosSinRetencion()
                );
            },
            fillFullPayment(field, amount) {
                if (!this.selectedRecord || this.selectedRecord.Status === 1) return;
                this.$set(this.editForm, field, this.round2(Math.max(0, this.toNumber(amount))));
            },

            buildPagoCuentaPayload(source = {}, ivaAPagar = this.ivaPagar) {
                const pagoCuentaIngresosConRetencion = this.toNumber(source.PagoCuentaIngresosConRetencion);
                const pagoCuentaIngresosSinRetencion = this.toNumber(source.PagoCuentaIngresosSinRetencion);
                const pagoCuentaRemanentePeriodoAnterior = this.toNumber(source.PagoCuentaRemanentePeriodoAnterior);
                const pagoCuentaRemanenteSiguientePeriodo = this.round2((pagoCuentaIngresosSinRetencion * 0.0175) + pagoCuentaRemanentePeriodoAnterior);
                const pagoCuentaAPagar = this.round2(Math.max(0, pagoCuentaRemanenteSiguientePeriodo));
                const pagoCuentaPagado = this.toNumber(source.PagoCuentaPagado);
                const pagoCuentaSaldoPendiente = this.round2(Math.max(0, pagoCuentaAPagar - pagoCuentaPagado));
                const rentaRetencionesConDependenciaLaboral = this.toNumber(source.RentaRetencionesConDependenciaLaboral);
                const rentaRetencionesSinDependenciaLaboralCantidad = this.toInt(source.RentaRetencionesSinDependenciaLaboralCantidad);
                const rentaRetencionesSinDependenciaLaboralMonto = this.toNumber(source.RentaRetencionesSinDependenciaLaboralMonto);
                const rentaRetencionesPorAlquilerCantidad = this.toInt(source.RentaRetencionesPorAlquilerCantidad);
                const rentaRetencionesPorAlquilerMonto = this.toNumber(source.RentaRetencionesPorAlquilerMonto);
                const sujetosExcluidosCantidad = this.toInt(source.SujetosExcluidosCantidad);
                const sujetosExcluidosMonto = this.toNumber(source.SujetosExcluidosMonto);
                const sujetosExcluidosRenta = this.toNumber(source.SujetosExcluidosRenta);
                const rentaRemanentePeriodoAnterior = this.toNumber(source.RentaRemanentePeriodoAnterior);
                const rentaTotalAPagarRetenciones = this.round2(Math.max(
                    0,
                    rentaRetencionesConDependenciaLaboral +
                    (rentaRetencionesSinDependenciaLaboralMonto * 0.10) +
                    (rentaRetencionesPorAlquilerMonto * 0.10) +
                    sujetosExcluidosRenta -
                    rentaRemanentePeriodoAnterior
                ));
                const rentaPagada = this.toNumber(source.RentaPagada);
                const rentaSaldoPendiente = this.round2(Math.max(0, rentaTotalAPagarRetenciones - rentaPagada));
                const totalAPagarMandamientos = this.round2(this.toNumber(ivaAPagar) + pagoCuentaAPagar + rentaTotalAPagarRetenciones);
                const totalPagadoMandamientos = this.toNumber(source.IvaPagado) + pagoCuentaPagado + rentaPagada;
                const totalSaldoPendienteMandamientos = this.round2(Math.max(0, totalAPagarMandamientos - totalPagadoMandamientos));

                return {
                    PagoCuentaIngresosConRetencion: this.round2(pagoCuentaIngresosConRetencion),
                    PagoCuentaIngresosSinRetencion: this.round2(pagoCuentaIngresosSinRetencion),
                    PagoCuentaRemanentePeriodoAnterior: this.round2(pagoCuentaRemanentePeriodoAnterior),
                    PagoCuentaRemanenteSiguientePeriodo: pagoCuentaRemanenteSiguientePeriodo,
                    PagoCuentaPagado: this.round2(pagoCuentaPagado),
                    PagoCuentaSaldoPendiente: pagoCuentaSaldoPendiente,
                    RentaRetencionesConDependenciaLaboral: rentaRetencionesConDependenciaLaboral,
                    RentaRetencionesSinDependenciaLaboralCantidad: rentaRetencionesSinDependenciaLaboralCantidad,
                    RentaRetencionesSinDependenciaLaboralMonto: this.round2(rentaRetencionesSinDependenciaLaboralMonto),
                    RentaRetencionesPorAlquilerCantidad: rentaRetencionesPorAlquilerCantidad,
                    RentaRetencionesPorAlquilerMonto: this.round2(rentaRetencionesPorAlquilerMonto),
                    RentaRemanentePeriodoAnterior: this.round2(rentaRemanentePeriodoAnterior),
                    SujetosExcluidosCantidad: sujetosExcluidosCantidad,
                    SujetosExcluidosMonto: this.round2(sujetosExcluidosMonto),
                    SujetosExcluidosRenta: this.round2(sujetosExcluidosRenta),
                    RentaTotalAPagarRetenciones: this.round2(rentaTotalAPagarRetenciones),
                    RentaPagada: this.round2(rentaPagada),
                    RentaSaldoPendiente: rentaSaldoPendiente,
                    TotalAPagarMandamientos: totalAPagarMandamientos,
                    TotalPagadoMandamientos: this.round2(totalPagadoMandamientos),
                    TotalSaldoPendienteMandamientos: totalSaldoPendienteMandamientos,
                };
            },

            async loadRecords() {
                try {
                    const res = await this.$API.accountingtotalsrecord.list();
                    const all = res.data.data || [];
                    this.allRecords = all.sort((a, b) => {
                        if (b.PeriodYear !== a.PeriodYear) return b.PeriodYear - a.PeriodYear;
                        return b.PeriodMonth - a.PeriodMonth;
                    });
                    this.records = this.allRecords.filter(r =>
                        r.PeriodMonth == this.search.month && r.PeriodYear == this.search.year
                    );
                    // Actualizar selectedRecord si sigue existiendo
                    if (this.selectedRecord) {
                        const updated = this.allRecords.find(r => r.ID === this.selectedRecord.ID);
                        if (updated) this.openRecord(updated);
                        else { this.selectedRecord = null; this.activeTab = 0; }
                    }
                } catch (err) {
                    this.showAlert('danger', 'Error', err?.response?.data?.message || 'Error al cargar los registros');
                }
            },

            openRecord(rec) {
                this.selectedRecord = rec;
                this.editForm = {
                    ...DECLARACION_PAGO_CUENTA_DEFAULTS,
                    VentasExentas:            this.toNumber(rec.VentasExentas),
                    VentasNoSujetas:          this.toNumber(rec.VentasNoSujetas),
                    VentasGravadasLocales:    this.toNumber(rec.VentasGravadasLocales),
                    VentasGravadasLocalesConsumidorFinal: this.toNumber(rec.VentasGravadasLocalesConsumidorFinal),
                    DebitoFiscalConsumidorFinal: this.toNumber(rec.DebitoFiscalConsumidorFinal),
                    VentasGravadasLocalesCreditoFiscal: this.toNumber(rec.VentasGravadasLocalesCreditoFiscal),
                    DebitoFiscalCreditoFiscal: this.toNumber(rec.DebitoFiscalCreditoFiscal),
                    DebitoFiscal:             this.toNumber(rec.DebitoFiscal),
                    TotalVentas:              this.toNumber(rec.TotalVentas),
                    ComprasExentas:           this.toNumber(rec.ComprasExentas),
                    ComprasGravadas:          this.toNumber(rec.ComprasGravadas),
                    CreditoFiscal:            this.toNumber(rec.CreditoFiscal),
                    TotalCompras:             this.toNumber(rec.TotalCompras),
                    DiferenciaIVA:            this.toNumber(rec.DiferenciaIVA),
                    RemanentePeriodoAnterior: this.toNumber(rec.RemanentePeriodoAnterior),
                    IvaRetencionVentas1: this.toNumber(rec.IvaRetencionVentas1 != null ? rec.IvaRetencionVentas1 : rec.IvaRetencion),
                    IvaRetencionCompras2: this.toNumber(rec.IvaRetencionCompras2),
                    IvaPercepcionCompras1: this.toNumber(rec.IvaPercepcionCompras1),
                    IvaPagado:                this.toNumber(rec.IvaPagado),
                    SaldoAcumuladoAnterior:   this.toNumber(rec.SaldoAcumuladoAnterior),
                    PagoCuentaIngresosConRetencion: this.toNumber(rec.PagoCuentaIngresosConRetencion),
                    PagoCuentaIngresosSinRetencion: this.toNumber(rec.PagoCuentaIngresosSinRetencion),
                    PagoCuentaRemanentePeriodoAnterior: this.toNumber(rec.PagoCuentaRemanentePeriodoAnterior),
                    PagoCuentaRemanenteSiguientePeriodo: this.toNumber(rec.PagoCuentaRemanenteSiguientePeriodo),
                    PagoCuentaPagado: this.toNumber(rec.PagoCuentaPagado),
                    PagoCuentaSaldoPendiente: this.toNumber(rec.PagoCuentaSaldoPendiente),
                    RentaRetencionesConDependenciaLaboral: this.toNumber(rec.RentaRetencionesConDependenciaLaboral),
                    RentaRetencionesSinDependenciaLaboralCantidad: this.toInt(rec.RentaRetencionesSinDependenciaLaboralCantidad),
                    RentaRetencionesSinDependenciaLaboralMonto: this.toNumber(rec.RentaRetencionesSinDependenciaLaboralMonto),
                    RentaRetencionesPorAlquilerCantidad: this.toInt(rec.RentaRetencionesPorAlquilerCantidad),
                    RentaRetencionesPorAlquilerMonto: this.toNumber(rec.RentaRetencionesPorAlquilerMonto),
                    RentaRemanentePeriodoAnterior: this.toNumber(rec.RentaRemanentePeriodoAnterior),
                    SujetosExcluidosCantidad: this.toInt(rec.SujetosExcluidosCantidad),
                    SujetosExcluidosMonto: this.toNumber(rec.SujetosExcluidosMonto),
                    SujetosExcluidosRenta: this.toNumber(rec.SujetosExcluidosRenta),
                    RentaTotalAPagarRetenciones: this.toNumber(rec.RentaTotalAPagarRetenciones),
                    RentaPagada: this.toNumber(rec.RentaPagada),
                    RentaSaldoPendiente: this.toNumber(rec.RentaSaldoPendiente),
                    TotalAPagarMandamientos: this.toNumber(rec.TotalAPagarMandamientos),
                    TotalPagadoMandamientos: this.toNumber(rec.TotalPagadoMandamientos),
                    TotalSaldoPendienteMandamientos: this.toNumber(rec.TotalSaldoPendienteMandamientos),
                };
                this.activeTab = 1;
            },

            async saveEdit() {
                await this.persistCurrentForm({ markProcessed: false });
            },

            confirmProcesar() {
                this.pendingProcesar = true;
                this.showAlert('question2', 'Confirmar', '¿Guardar los cambios y marcar este período como Procesado? No podrá editarse después.');
            },

            async persistCurrentForm({ markProcessed = false } = {}) {
                if (!this.selectedRecord || this.selectedRecord.Status === 1) return;
                this.loading = true;
                try {
                    const recordId = this.selectedRecord.ID;
                    const ivaPagado = this.round2(this.toNumber(this.editForm.IvaPagado));
                    const pagoCuentaPagado = this.round2(this.toNumber(this.editForm.PagoCuentaPagado));
                    const rentaPagada = this.round2(this.toNumber(this.editForm.RentaPagada));
                    const paymentPayload = {
                        IvaPagado: ivaPagado,
                        IvaAPagar: this.ivaPagar,
                        SaldoPendiente: this.saldoPendiente,
                        PagoCuentaPagado: pagoCuentaPagado,
                        PagoCuentaSaldoPendiente: this.round2(Math.max(0, this.pagoCuentaAPagar - pagoCuentaPagado)),
                        RentaPagada: rentaPagada,
                        RentaSaldoPendiente: this.round2(Math.max(0, this.rentaTotalRetenciones - rentaPagada)),
                        TotalAPagarMandamientos: this.totalAPagarMandamientos,
                        TotalPagadoMandamientos: this.round2(ivaPagado + pagoCuentaPagado + rentaPagada),
                        TotalSaldoPendienteMandamientos: this.round2(Math.max(0, this.totalAPagarMandamientos - (ivaPagado + pagoCuentaPagado + rentaPagada))),
                    };

                    this.$set(this.editForm, 'IvaPagado', ivaPagado);
                    this.$set(this.editForm, 'PagoCuentaPagado', pagoCuentaPagado);
                    this.$set(this.editForm, 'RentaPagada', rentaPagada);
                    this.$set(this.editForm, 'PagoCuentaSaldoPendiente', paymentPayload.PagoCuentaSaldoPendiente);
                    this.$set(this.editForm, 'RentaSaldoPendiente', paymentPayload.RentaSaldoPendiente);
                    this.$set(this.editForm, 'SaldoPendiente', paymentPayload.SaldoPendiente);
                    this.$set(this.editForm, 'TotalPagadoMandamientos', paymentPayload.TotalPagadoMandamientos);
                    this.$set(this.editForm, 'TotalSaldoPendienteMandamientos', paymentPayload.TotalSaldoPendienteMandamientos);

                    await this.$API.accountingtotalsrecord.generate({
                        PeriodMonth: this.selectedRecord.PeriodMonth,
                        PeriodYear:  this.selectedRecord.PeriodYear,
                        IvaRetencion: this.ivaRetencionTotal,
                        ...this.editForm,
                        ...this.buildPagoCuentaPayload(this.editForm, this.ivaPagar),
                        ...paymentPayload,
                    });

                    if (markProcessed) {
                        await this.$API.accountingtotalsrecord.confirm(recordId);
                    }

                    await this.loadRecords();
                    this.activeTab = 0;
                    this.showAlert(
                        'success',
                        markProcessed ? 'Procesado' : 'Guardado',
                        markProcessed
                            ? 'Los cambios fueron guardados y el período fue marcado como Procesado.'
                            : 'Los cambios fueron guardados correctamente.'
                    );
                } catch (err) {
                    this.showAlert('danger', 'Error', err?.response?.data?.message || (markProcessed ? 'Error al procesar' : 'Error al guardar'));
                } finally {
                    this.loading = false;
                }
            },

            async generateAndSave() {
                if (this.search.month == null || this.search.year == null) return;
                this.loading = true;
                try {
                    const res = await this.$API.accountingreports.getTotalsSalesPurchasesByDate({ ...this.search, dataType: this.dataType });
                    const row = (res.data.data || res.data || [])[0];
                    if (!row) {
                        this.showAlert('warning', 'Sin datos', 'No se encontraron datos para el período seleccionado.');
                        return;
                    }
                    if (!row['PREV_RECORD_FOUND']) {
                        const prevMonth = this.search.month === 1 ? 12 : this.search.month - 1;
                        const prevYear  = this.search.month === 1 ? this.search.year - 1 : this.search.year;
                        const prevName  = `${MONTH_NAMES[prevMonth - 1]} ${prevYear}`;
                        this.pendingGenerateRow = row;
                        this.showAlert('question2', 'Sin registro del período anterior',
                            `No se encontró un registro guardado para ${prevName}. El Remanente Período Anterior se guardará como $0.00. ¿Desea continuar?`);
                        return;
                    }
                    await this._doSave(row);
                } catch (err) {
                    this.showAlert('danger', 'Error', err?.response?.data?.message || 'Error al generar los totales');
                } finally {
                    this.loading = false;
                }
            },

            async _doSave(row, force = false) {
                if (!force) {
                    const existingEditable = this.allRecords.find(r =>
                        r.PeriodMonth == this.search.month &&
                        r.PeriodYear  == this.search.year  &&
                        r.Status == 0
                    );
                    if (existingEditable) {
                        const label = `${MONTH_NAMES[this.search.month - 1]} ${this.search.year}`;
                        this.pendingOverwriteRow = row;
                        this.showAlert('question2', 'Registro existente',
                            `Ya existe un registro editable para ${label}. ¿Desea sobreescribirlo con los datos actuales del sistema?`);
                        return;
                    }
                }
                const existingRecord = this.allRecords.find(r =>
                    r.PeriodMonth == this.search.month && r.PeriodYear == this.search.year
                );
                const prevMonth = this.search.month === 1 ? 12 : this.search.month - 1;
                const prevYear = this.search.month === 1 ? this.search.year - 1 : this.search.year;
                const previousPeriodRecord = this.allRecords.find(r =>
                    r.PeriodMonth == prevMonth && r.PeriodYear == prevYear
                );
                const difIVA = parseFloat(row['DIFERENCIA IVA'] || 0);
                const remAnt = parseFloat(row['REMANENTE PERIODO ANTERIOR'] || 0);
                const ivaRetencionVentas1 = parseFloat(row['RETENCION IVA 1%'] || 0);
                const ivaRetencionCompras2 = parseFloat(row['RETENCION IVA 2%'] || 0);
                const ivaPercepcionCompras1 = parseFloat(row['PERCEPCION IVA 1%'] || 0);
                const ivaRetencionTotal = this.round2(ivaRetencionVentas1 + ivaRetencionCompras2 + ivaPercepcionCompras1);
                const ivaNeto = difIVA - remAnt - ivaRetencionTotal;
                // Sumar saldos pendientes de todos los períodos anteriores sin pagar
                const saldoAcumulado = this.allRecords
                    .filter(r => {
                        if (r.PeriodYear  <  this.search.year) return true;
                        if (r.PeriodYear === this.search.year && r.PeriodMonth < this.search.month) return true;
                        return false;
                    })
                    .reduce((sum, r) => sum + Math.max(0, parseFloat(r.SaldoPendiente || 0)), 0);
                // El remanente (ivaNeto negativo) reduce el saldo acumulado
                const ivaAP = Math.max(0, ivaNeto + saldoAcumulado);
                const pagoCuentaSource = {
                    ...(existingRecord || DECLARACION_PAGO_CUENTA_DEFAULTS),
                    TotalVentas: parseFloat(row['TOTAL VENTAS'] || 0),
                    PagoCuentaIngresosSinRetencion:
                        parseFloat(row['TOTAL VENTAS'] || 0) -
                        this.toNumber((existingRecord || DECLARACION_PAGO_CUENTA_DEFAULTS).PagoCuentaIngresosConRetencion),
                    PagoCuentaRemanentePeriodoAnterior: previousPeriodRecord
                        ? this.toNumber(previousPeriodRecord.PagoCuentaSaldoPendiente || previousPeriodRecord.PagoCuentaRemanenteSiguientePeriodo)
                        : 0,
                };
                const pagoCuentaPayload = this.buildPagoCuentaPayload(pagoCuentaSource, ivaAP);
                const sujetosExcluidosPayload = {
                    SujetosExcluidosCantidad: this.toInt(row['SUJETOS EXCLUIDOS CANTIDAD']),
                    SujetosExcluidosMonto: this.toNumber(row['SUJETOS EXCLUIDOS MONTO']),
                    SujetosExcluidosRenta: this.toNumber(row['SUJETOS EXCLUIDOS RENTA']),
                };
                const generatedPayload = {
                    PeriodMonth: this.search.month,
                    PeriodYear: this.search.year,
                    VentasExentas: parseFloat(row['VENTAS EXENTAS'] || 0),
                    VentasNoSujetas: parseFloat(row['VENTAS NO SUJETAS'] || 0),
                    VentasGravadasLocales: parseFloat(row['VENTAS GRAVADAS LOCALES'] || 0),
                    VentasGravadasLocalesConsumidorFinal: parseFloat(row['VENTAS GRAVADAS LOCALES CONSUMIDOR FINAL'] || row.ventasGravadasCF || 0),
                    DebitoFiscalConsumidorFinal: parseFloat(row['DÉBITO FISCAL CONSUMIDOR FINAL'] || row.debitoFiscalCF || 0),
                    VentasGravadasLocalesCreditoFiscal: parseFloat(row['VENTAS GRAVADAS LOCALES CREDITO FISCAL'] || row['VENTAS GRAVADAS LOCALES CRÉDITO FISCAL'] || row.ventasGravadasCCF || 0),
                    DebitoFiscalCreditoFiscal: parseFloat(row['DÉBITO FISCAL CREDITO FISCAL'] || row['DÉBITO FISCAL CRÉDITO FISCAL'] || row.debitoFiscalCCF || 0),
                    DebitoFiscal: parseFloat(row['DÉBITO FISCAL'] || 0),
                    TotalVentas: parseFloat(row['TOTAL VENTAS'] || 0),
                    ComprasExentas: parseFloat(row['COMPRAS EXENTAS Y/O NO SUJETAS'] || 0),
                    ComprasGravadas: parseFloat(row['COMPRAS GRAVADAS'] || 0),
                    CreditoFiscal: parseFloat(row['CRÉDITO FISCAL'] || 0),
                    TotalCompras: parseFloat(row['TOTAL COMPRAS'] || 0),
                    DiferenciaIVA: difIVA,
                    RemanentePeriodoAnterior: remAnt,
                    IvaAPagar: ivaAP,
                    IvaPagado: 0,
                    SaldoPendiente: this.round2(ivaNeto + saldoAcumulado),
                    IvaRetencion: ivaRetencionTotal,
                    IvaRetencionVentas1: ivaRetencionVentas1,
                    IvaRetencionCompras2: ivaRetencionCompras2,
                    IvaPercepcionCompras1: ivaPercepcionCompras1,
                    SaldoAcumuladoAnterior: saldoAcumulado,
                    ...pagoCuentaPayload,
                    ...sujetosExcluidosPayload,
                };
                const generatedLog = JSON.stringify({
                    source: 'generate',
                    generatedAt: new Date().toISOString(),
                    backendSummaryRow: row,
                    payload: generatedPayload,
                });

                const saveRes = await this.$API.accountingtotalsrecord.generate({
                    ...generatedPayload,
                    Logs: generatedLog,
                });
                await this.loadRecords();
                if (saveRes.data.locked) {
                    this.showAlert('warning', 'Período confirmado', 'Este período ya está confirmado y no puede modificarse.');
                } else {
                    // Abrir automáticamente en tab declaración
                    const newRec = this.allRecords.find(r =>
                        r.PeriodMonth == this.search.month && r.PeriodYear == this.search.year
                    );
                    if (newRec) this.openRecord(newRec);
                    this.showAlert('success', 'Éxito', 'Totales generados. Revise y edite si necesita, luego márquelo como Procesado.');
                }
            },

            async savePayment() {
                if (!this.selectedRecord) return;
                const ivaPagado = this.round2(this.toNumber(this.editForm.IvaPagado));
                const pagoCuentaPagado = this.round2(this.toNumber(this.editForm.PagoCuentaPagado));
                const rentaPagada = this.round2(this.toNumber(this.editForm.RentaPagada));

                if (ivaPagado < 0 || pagoCuentaPagado < 0 || rentaPagada < 0) {
                    this.showAlert('warning', 'Valor inválido', 'Los montos pagados no pueden ser negativos.');
                    return;
                }
                if (ivaPagado > this.ivaPagar) {
                    this.showAlert('warning', 'Valor inválido',
                        `El monto pagado ($${this.fmt(ivaPagado)}) no puede superar el IVA a pagar ($${this.fmt(this.ivaPagar)}).`);
                    return;
                }
                if (pagoCuentaPagado > this.pagoCuentaAPagar) {
                    this.showAlert('warning', 'Valor inválido',
                        `El monto pagado de pago a cuenta ($${this.fmt(pagoCuentaPagado)}) no puede superar el saldo a pagar ($${this.fmt(this.pagoCuentaAPagar)}).`);
                    return;
                }
                if (rentaPagada > this.rentaTotalRetenciones) {
                    this.showAlert('warning', 'Valor inválido',
                        `El monto pagado de retenciones de renta ($${this.fmt(rentaPagada)}) no puede superar el saldo a pagar ($${this.fmt(this.rentaTotalRetenciones)}).`);
                    return;
                }
                this.loading = true;
                try {
                    await this.$API.accountingtotalsrecord.updatePayment(this.selectedRecord.ID, {
                        IvaPagado:      ivaPagado,
                        IvaAPagar:      this.ivaPagar,
                        SaldoPendiente: this.saldoPendiente,
                        PagoCuentaPagado: pagoCuentaPagado,
                        PagoCuentaSaldoPendiente: this.round2(Math.max(0, this.pagoCuentaAPagar - pagoCuentaPagado)),
                        RentaPagada: rentaPagada,
                        RentaSaldoPendiente: this.round2(Math.max(0, this.rentaTotalRetenciones - rentaPagada)),
                        TotalAPagarMandamientos: this.totalAPagarMandamientos,
                        TotalPagadoMandamientos: this.round2(ivaPagado + pagoCuentaPagado + rentaPagada),
                        TotalSaldoPendienteMandamientos: this.round2(Math.max(0, this.totalAPagarMandamientos - (ivaPagado + pagoCuentaPagado + rentaPagada))),
                    });
                    await this.loadRecords();
                    this.showAlert('success', 'Pago registrado',
                        this.totalSaldoPendienteMandamientos > 0
                            ? `Pago parcial registrado. Saldo pendiente total: $${this.fmt(this.totalSaldoPendienteMandamientos)}`
                            : 'Mandamientos pagados en su totalidad.');
                } catch (err) {
                    this.showAlert('danger', 'Error', err?.response?.data?.message || 'Error al registrar el pago');
                } finally {
                    this.loading = false;
                }
            },

            confirmDelete(rec) {
                this.pendingDelete = rec;
                const label = `${this.monthName(rec.PeriodMonth)} ${rec.PeriodYear}`;
                this.showAlert('question', 'Eliminar registro',
                    `¿Está seguro que desea eliminar el registro de ${label}? Esta acción no se puede deshacer.`);
            },

            async confirmRecord(row) {
                await this.$API.accountingtotalsrecord.confirm(row.ID);
                await this.loadRecords();
            },

            async acceptAlert() {
                this.alert.show = false;
                if (this.pendingDelete) {
                    try {
                        await this.$API.accountingtotalsrecord.remove(this.pendingDelete.ID);
                        await this.loadRecords();
                    } catch (err) {
                        this.showAlert('danger', 'Error', err?.response?.data?.message || 'Error al eliminar');
                    } finally {
                        this.pendingDelete = null;
                    }
                } else if (this.pendingProcesar) {
                    this.pendingProcesar = false;
                    this.loading = true;
                    try {
                        await this.persistCurrentForm({ markProcessed: true });
                    } catch (err) {
                        this.showAlert('danger', 'Error', err?.response?.data?.message || 'Error al procesar');
                    } finally {
                        this.loading = false;
                    }
                } else if (this.pendingOverwriteRow) {
                    const row = this.pendingOverwriteRow;
                    this.pendingOverwriteRow = null;
                    this.loading = true;
                    try {
                        await this._doSave(row, true);
                    } catch (err) {
                        this.showAlert('danger', 'Error', err?.response?.data?.message || 'Error al generar los totales');
                    } finally {
                        this.loading = false;
                    }
                } else if (this.pendingGenerateRow) {
                    const row = this.pendingGenerateRow;
                    this.pendingGenerateRow = null;
                    this.loading = true;
                    try {
                        await this._doSave(row);
                    } catch (err) {
                        this.showAlert('danger', 'Error', err?.response?.data?.message || 'Error al generar los totales');
                    } finally {
                        this.loading = false;
                    }
                }
            },

            async exportExcel(record) {
                try {
                    const workbook = new ExcelJS.Workbook();
                    const ws = workbook.addWorksheet('Declaración IVA');
                    this._buildIVASheet(ws, record, this.businessName);
                    const monthLabel = MONTH_NAMES[(record.PeriodMonth || 1) - 1].toUpperCase();
                    const buffer = await workbook.xlsx.writeBuffer();
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }),
                        `DeclaracionIVA_${monthLabel}_${record.PeriodYear}.xlsx`);
                } catch (error) {
                    console.error('Error al exportar Excel:', error);
                    this.showAlert('danger', 'Error', 'Ocurrió un error al generar el archivo Excel.');
                }
            },

            _buildIVASheet(ws, record, bName) {
                const monthLabel = MONTH_NAMES[(record.PeriodMonth || 1) - 1].toUpperCase();
                const year = record.PeriodYear;
                ws.getColumn('A').width = 34;
                ws.getColumn('B').width = 2;
                ws.getColumn('C').width = 16;
                ws.getColumn('D').width = 16;
                ws.getColumn('F').width = 4;
                ws.getColumn('G').width = 34;
                ws.getColumn('H').width = 12;
                ws.getColumn('I').width = 16;
                ws.getColumn('J').width = 16;

                const fmt = '_("$"* #,##0.00_);[Red]_("$"* (#,##0.00);_("$"* "-"??_);_(@_)';
                const solidFill = (argb) => ({ type: 'pattern', pattern: 'solid', fgColor: { argb } });
                const side = (argb = 'FF000000') => ({ style: 'thin', color: { argb } });
                const borders = (argb = 'FF000000') => ({ top: side(argb), left: side(argb), bottom: side(argb), right: side(argb) });
                const headerFill = solidFill('FFF2F2F2');
                const GRAY_BORDER = 'FFAAAAAA';
                const n = (v) => this.toNumber(v);
                const r = record;
                const colLetter = (index) => {
                    let dividend = index;
                    let columnName = '';
                    while (dividend > 0) {
                        const modulo = (dividend - 1) % 26;
                        columnName = String.fromCharCode(65 + modulo) + columnName;
                        dividend = Math.floor((dividend - modulo) / 26);
                    }
                    return columnName;
                };
                const cellRef = (col, row) => `${colLetter(col)}${row}`;
                const mergeRow = (startCol, endCol, row) => ws.mergeCells(`${cellRef(startCol, row)}:${cellRef(endCol, row)}`);
                const styleMap = {
                    total: { fill: 'FF2F6D9A', font: 'FFFFFFFF' },
                    gray: { fill: 'FFEAF2F8', font: 'FF1F2937' },
                    green: { fill: 'FFDCECF8', font: 'FF1F2937' },
                    cyan: { fill: 'FF59A9DD', font: 'FFFFFFFF' },
                    dark: { fill: 'FF2A5678', font: 'FFFFFFFF' },
                    peach: { fill: 'FFD8E9F6', font: 'FF1F2937' },
                };
                const applyStyle = (cells, style) => {
                    if (!styleMap[style]) return;
                    cells.forEach((cell) => {
                        cell.fill = solidFill(styleMap[style].fill);
                        cell.font = { bold: true, color: { argb: styleMap[style].font } };
                    });
                };
                const buildTitle = (startCol, endCol, row, text, fill, fontColor = 'FFFFFFFF', size = 13) => {
                    mergeRow(startCol, endCol, row);
                    const titleCell = ws.getCell(cellRef(startCol, row));
                    titleCell.value = text;
                    titleCell.fill = solidFill(fill);
                    titleCell.font = { bold: true, size, color: { argb: fontColor } };
                    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
                };
                const addMergedMoneyRow = (startCol, rowNum, desc, firstValue, secondValue, style) => {
                    mergeRow(startCol, startCol + 1, rowNum);
                    const descCell = ws.getCell(cellRef(startCol, rowNum));
                    const firstCell = ws.getCell(cellRef(startCol + 2, rowNum));
                    const secondCell = ws.getCell(cellRef(startCol + 3, rowNum));
                    descCell.value = desc || null;
                    descCell.alignment = { vertical: 'middle', indent: 1 };
                    firstCell.alignment = { horizontal: 'right', vertical: 'middle' };
                    secondCell.alignment = { horizontal: 'right', vertical: 'middle' };
                    if (firstValue !== null && firstValue !== undefined) {
                        firstCell.value = firstValue;
                        firstCell.numFmt = fmt;
                    }
                    if (secondValue !== null && secondValue !== undefined) {
                        secondCell.value = secondValue;
                        secondCell.numFmt = fmt;
                    }
                    [descCell, firstCell, secondCell].forEach((cell) => { cell.border = borders(GRAY_BORDER); });
                    applyStyle([descCell, firstCell, secondCell], style);
                };
                const addSectionHeader = (startCol, endCol, rowNum, text, style = 'peach') => {
                    mergeRow(startCol, endCol, rowNum);
                    const headerCell = ws.getCell(cellRef(startCol, rowNum));
                    headerCell.value = text;
                    headerCell.alignment = { horizontal: 'center', vertical: 'middle' };
                    headerCell.border = borders(GRAY_BORDER);
                    applyStyle([headerCell], style);
                };
                const addLeftSectionHeader = (startCol, endCol, rowNum, text, style = 'peach') => {
                    mergeRow(startCol, endCol, rowNum);
                    const headerCell = ws.getCell(cellRef(startCol, rowNum));
                    headerCell.value = text;
                    headerCell.alignment = { horizontal: 'left', vertical: 'middle', indent: 1 };
                    headerCell.border = borders(GRAY_BORDER);
                    applyStyle([headerCell], style);
                };
                const addRightRow = (rowNum, desc, qty, amount, rent, style) => {
                    const descCell = ws.getCell(cellRef(7, rowNum));
                    const qtyCell = ws.getCell(cellRef(8, rowNum));
                    const amountCell = ws.getCell(cellRef(9, rowNum));
                    const rentCell = ws.getCell(cellRef(10, rowNum));
                    descCell.value = desc || null;
                    descCell.alignment = { vertical: 'middle', indent: 1 };
                    qtyCell.alignment = amountCell.alignment = rentCell.alignment = { horizontal: 'right', vertical: 'middle' };
                    if (qty !== null && qty !== undefined) qtyCell.value = qty;
                    if (amount !== null && amount !== undefined) {
                        amountCell.value = amount;
                        amountCell.numFmt = fmt;
                    }
                    if (rent !== null && rent !== undefined) {
                        rentCell.value = rent;
                        rentCell.numFmt = fmt;
                    }
                    [descCell, qtyCell, amountCell, rentCell].forEach((cell) => { cell.border = borders(GRAY_BORDER); });
                    applyStyle([descCell, qtyCell, amountCell, rentCell], style);
                };
                const addPagoCuentaRow = (rowNum, desc, amount, result, style) => {
                    mergeRow(7, 8, rowNum);
                    const descCell = ws.getCell(cellRef(7, rowNum));
                    const amountCell = ws.getCell(cellRef(9, rowNum));
                    const resultCell = ws.getCell(cellRef(10, rowNum));
                    descCell.value = desc || null;
                    descCell.alignment = { vertical: 'middle', indent: 1 };
                    amountCell.alignment = resultCell.alignment = { horizontal: 'right', vertical: 'middle' };
                    if (amount !== null && amount !== undefined) {
                        amountCell.value = amount;
                        amountCell.numFmt = fmt;
                    }
                    if (result !== null && result !== undefined) {
                        resultCell.value = result;
                        resultCell.numFmt = fmt;
                    }
                    [descCell, amountCell, resultCell].forEach((cell) => { cell.border = borders(GRAY_BORDER); });
                    applyStyle([descCell, amountCell, resultCell], style);
                };

                ws.getRow(3).height = 26;
                ws.getRow(4).height = 18;

                buildTitle(1, 4, 3, `${bName}   ${monthLabel} ${year}`, 'FF59A9DD');
                buildTitle(1, 4, 4, 'DECLARACION DE IVA', 'FF2A5678', 'FFFFFFFF', 11);
                buildTitle(7, 10, 3, `${bName}   ${monthLabel} ${year}`, 'FF59A9DD');
                buildTitle(7, 10, 4, 'DECLARACION DE PAGO A CUENTA', 'FF2A5678', 'FFFFFFFF', 11);

                mergeRow(1, 2, 5);
                const hDesc = ws.getCell('A5');
                hDesc.value = 'Descripción';
                hDesc.fill = headerFill;
                hDesc.font = { bold: true };
                hDesc.alignment = { horizontal: 'left', indent: 1 };
                hDesc.border = borders();
                const hMonto = ws.getCell('C5');
                hMonto.value = 'Monto';
                hMonto.fill = headerFill;
                hMonto.font = { bold: true };
                hMonto.alignment = { horizontal: 'center' };
                hMonto.border = borders();
                const hIVA = ws.getCell('D5');
                hIVA.value = 'IVA';
                hIVA.fill = headerFill;
                hIVA.font = { bold: true };
                hIVA.alignment = { horizontal: 'center' };
                hIVA.border = borders();

                addMergedMoneyRow(1, 6,  'Compras gravadas',                      n(r.ComprasGravadas),                        n(r.CreditoFiscal));
                addMergedMoneyRow(1, 7,  'Importaciones de servicios',            0,                                           0);
                addMergedMoneyRow(1, 8,  'Importaciones e internaciones',         0,                                           0);
                addMergedMoneyRow(1, 9,  'Compras exentas',                       n(r.ComprasExentas),                         0);
                addMergedMoneyRow(1, 10, 'Compras no sujetas',                    0,                                           0);
                addMergedMoneyRow(1, 11, 'Compras sujetos excluidos',             0,                                           0);
                addMergedMoneyRow(1, 12, 'Total Compras',                         n(r.TotalCompras),                           n(r.CreditoFiscal), 'total');
                addMergedMoneyRow(1, 13, 'Ventas a Consumidor Final con Factura', n(r.VentasGravadasLocalesConsumidorFinal),   n(r.DebitoFiscalConsumidorFinal));
                addMergedMoneyRow(1, 14, 'Ventas a Contribuyentes con CCF',       n(r.VentasGravadasLocalesCreditoFiscal),     n(r.DebitoFiscalCreditoFiscal));
                addMergedMoneyRow(1, 15, 'Notas de Crédito',                      0,                                           0);
                addMergedMoneyRow(1, 16, 'Ventas por Exportaciones',              0,                                           0);
                addMergedMoneyRow(1, 17, 'Ventas exentas/ no sujetas',            n(r.VentasExentas) + n(r.VentasNoSujetas),   0);
                addMergedMoneyRow(1, 18, 'Total Ventas',                          n(r.TotalVentas),                            n(r.DebitoFiscal), 'total');

                const remAnt = n(r.RemanentePeriodoAnterior);
                const difIVA = n(r.DiferenciaIVA);
                const retencionIva1 = n(r.IvaRetencionVentas1 != null ? r.IvaRetencionVentas1 : r.IvaRetencion);
                const retencionIva2 = n(r.IvaRetencionCompras2);
                const percepcionIva1Compras = n(r.IvaPercepcionCompras1);
                const retencionIvaTotal = retencionIva1 + retencionIva2 + percepcionIva1Compras;
                const ivaBase = difIVA - remAnt;
                const ivaNetoPos = ivaBase - retencionIvaTotal;
                const remProximo = ivaNetoPos < 0 ? Math.abs(ivaNetoPos) : 0;
                const ivaPagar = ivaNetoPos > 0 ? ivaNetoPos : 0;

                addMergedMoneyRow(1, 19, 'IVA por Pagar/Remanente antes de retenciones', null, ivaBase, 'gray');
                addMergedMoneyRow(1, 20, 'Remanente Periodo anterior',     null, remAnt);
                addMergedMoneyRow(1, 21, 'Menos: Retención IVA 1%',        null, retencionIva1);
                addMergedMoneyRow(1, 22, 'Menos: Retención IVA 2%',        null, retencionIva2);
                addMergedMoneyRow(1, 23, 'Menos: Percepción IVA 1%',       null, percepcionIva1Compras);
                addMergedMoneyRow(1, 24, 'Total retenciones/percepciones IVA', null, retencionIvaTotal);
                addMergedMoneyRow(1, 25, 'Remanente para próximo periodo', null, remProximo, 'green');
                addMergedMoneyRow(1, 26, 'IVA por pagar (Remanente)',      null, ivaPagar, 'cyan');

                const pagoCuentaIngresosSinRetencion = n(r.PagoCuentaIngresosSinRetencion);
                const pagoCuentaCalculado = pagoCuentaIngresosSinRetencion * 0.0175;
                const pagoCuentaRemanentePeriodoAnterior = n(r.PagoCuentaRemanentePeriodoAnterior);
                const pagoCuentaRemanenteSiguientePeriodo = pagoCuentaCalculado + pagoCuentaRemanentePeriodoAnterior;
                const pagoCuentaAPagar = Math.max(0, pagoCuentaRemanenteSiguientePeriodo);
                const rentaSinDependencia = n(r.RentaRetencionesSinDependenciaLaboralMonto) * 0.10;
                const rentaPorAlquiler = n(r.RentaRetencionesPorAlquilerMonto) * 0.10;
                const sujetosExcluidosCantidad = this.toInt(r.SujetosExcluidosCantidad);
                const sujetosExcluidosMonto = n(r.SujetosExcluidosMonto);
                const sujetosExcluidosRenta = n(r.SujetosExcluidosRenta);
                const rentaTotalRetencionesExcel = Math.max(
                    0,
                    n(r.RentaRetencionesConDependenciaLaboral) +
                    rentaSinDependencia +
                    rentaPorAlquiler +
                    sujetosExcluidosRenta
                );
                const totalMandamientos = n(r.IvaAPagar) + pagoCuentaAPagar + rentaTotalRetencionesExcel;
                const totalPagadoMandamientos = n(r.IvaPagado) + n(r.PagoCuentaPagado) + n(r.RentaPagada);
                const totalSaldoPendienteMandamientos = Math.max(0, totalMandamientos - totalPagadoMandamientos);

                addLeftSectionHeader(7, 10, 5, 'PAGO A CUENTA');
                addPagoCuentaRow(6, 'Ingresos con retencion Pago a cuenta', n(r.PagoCuentaIngresosConRetencion), null);
                addPagoCuentaRow(7, 'Ingresos sin retencion Pago a cuenta', pagoCuentaIngresosSinRetencion, pagoCuentaCalculado);
                addPagoCuentaRow(8, 'Remanente Periodo anterior', null, -pagoCuentaRemanentePeriodoAnterior);
                addPagoCuentaRow(9, 'Pago (Remanente Siguiente Periodo)', null, pagoCuentaRemanenteSiguientePeriodo, 'cyan');

                const rentaHeaderRow = 11;
                const rentaDescHeader = ws.getCell(cellRef(7, rentaHeaderRow));
                rentaDescHeader.value = 'RETENCIONES DE RENTA';
                rentaDescHeader.font = { bold: true };
                rentaDescHeader.alignment = { horizontal: 'left', vertical: 'middle' };
                rentaDescHeader.border = borders(GRAY_BORDER);
                ['H11', 'I11', 'J11'].forEach((ref, index) => {
                    const labels = ['Cantidad', 'Monto', 'Renta'];
                    const headerCell = ws.getCell(ref);
                    headerCell.value = labels[index];
                    headerCell.font = { bold: true };
                    headerCell.alignment = { horizontal: 'center', vertical: 'middle' };
                    headerCell.border = borders(GRAY_BORDER);
                });

                addRightRow(12, 'Retenciones con dependencia laboral',         null, null, n(r.RentaRetencionesConDependenciaLaboral));
                addRightRow(13, 'Retenciones sin dependencia laboral',         n(r.RentaRetencionesSinDependenciaLaboralCantidad), n(r.RentaRetencionesSinDependenciaLaboralMonto), rentaSinDependencia);
                addRightRow(14, 'Retenciones por alquiler o arrendamiento',    n(r.RentaRetencionesPorAlquilerCantidad), n(r.RentaRetencionesPorAlquilerMonto), rentaPorAlquiler);
                addRightRow(15, 'Sujetos excluidos',                          sujetosExcluidosCantidad, sujetosExcluidosMonto, sujetosExcluidosRenta);
                addRightRow(16, 'Total a pagar retenciones',                   null, null, rentaTotalRetencionesExcel, 'cyan');

                addSectionHeader(7, 10, 20, 'Resumen de Impuesto:', 'dark');
                addRightRow(21, 'IVA',                     null, null, n(r.IvaAPagar));
                addRightRow(22, 'Pago a cuenta',           null, null, pagoCuentaAPagar);
                addRightRow(23, 'Retenciones',             null, null, rentaTotalRetencionesExcel);
                addRightRow(24, 'Total a pagar en mandamientos', null, null, totalMandamientos, 'total');
                addRightRow(25, 'Total pagado',            null, null, totalPagadoMandamientos);
                addRightRow(26, 'Saldo pendiente total',   null, null, totalSaldoPendienteMandamientos);
            },

            formatMonth({ value }) {
                return MONTH_NAMES[(value || 1) - 1] || value;
            },
            showAlert(type, header, body, options = null) {
                this.alert.type = type || 'danger';
                this.alert.header = header;
                this.alert.body = body;
                this.alert.options = options;
                this.alert.show = true;
            },
            closeAlert() {
                this.alert.show = false;
                this.pendingDelete = null;
                this.pendingGenerateRow = null;
                this.pendingOverwriteRow = null;
                this.pendingProcesar = false;
            },
        },
    };
</script>

<style scoped>
.bar {
    width: 100%;
    background-color: rgb(60, 60, 60) !important;
    color: white !important;
    border-style: solid;
    border-color: black;
    border-radius: 15px !important;
    margin-top: 1rem !important;
}
.selected-row {
    background-color: #e3f2fd !important;
}
.period-table-scroll {
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    max-width: 100%;
}
.period-table {
    min-width: 2500px;
    width: 100%;
}
.period-table th,
.period-table td {
    white-space: nowrap;
}
.period-table ::v-deep .v-data-table__wrapper {
    overflow-x: visible !important;
    overflow-y: visible !important;
}
.period-table thead tr:nth-child(2) th:nth-child(1),
.period-table thead tr:nth-child(2) th:nth-child(9),
.period-table thead tr:nth-child(2) th:nth-child(15),
.period-table tbody tr td:nth-child(4),
.period-table tbody tr td:nth-child(12),
.period-table tbody tr td:nth-child(18) {
    border-left: 2px solid #b8c2cc;
}
.decl-header {
    text-align: center;
    padding: 16px;
    border: 1px solid #ddd;
    border-radius: 6px;
    color: #333;
}
.decl-title {
    font-size: 16px;
    font-weight: bold;
}
.decl-subtitle {
    font-size: 13px;
    color: #444;
    margin-top: 4px;
}
.decl-panels {
    display: grid;
    gap: 20px;
}
.decl-panel {
    border: 1px solid #d8dee6;
    border-radius: 8px;
    padding: 18px;
}
.decl-panel__title {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #1f3a5f;
    margin-bottom: 14px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e5e7eb;
}
.stats-card {
    border: 1px solid #d8dee6;
    border-radius: 8px;
    padding: 18px 20px;
}
.stats-card__title {
    font-size: 12px;
    font-weight: 700;
    color: #243b53;
    margin-bottom: 12px;
}
.stats-card ::v-deep .row {
    margin-top: 0;
    margin-bottom: 0;
}
.stats-card ::v-deep .col-12,
.stats-card ::v-deep .col-sm-6,
.stats-card ::v-deep .col-md-3 {
    padding-top: 10px;
    padding-bottom: 10px;
}
.stat-box {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 12px 14px;
    min-height: 68px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.stat-box--accent {
    border-color: #b8c2cc;
}
.stat-box__label {
    font-size: 10px;
    font-weight: 700;
    color: #5d6b82;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin-bottom: 6px;
}
.stat-box__value {
    font-size: 15px;
    line-height: 1.1;
    font-weight: 700;
    color: #334155;
}
.section-header {
    display: grid;
    grid-template-columns: minmax(170px, 0.85fr) minmax(210px, 1fr) minmax(210px, 1fr);
    column-gap: 14px;
    align-items: center;
    background: #F2F2F2;
    border-left: 4px solid #999;
    padding: 6px 12px;
    font-weight: bold;
    font-size: 13px;
    margin: 12px 0 4px;
    color: #374151;
    border-radius: 3px;
}
.section-header__column {
    color: #5d6b82;
    font-size: 11px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
}
.section-header--single-value {
    grid-template-columns: minmax(170px, 0.85fr) minmax(210px, 1fr) minmax(210px, 1fr);
}
.section-header--single-value .section-header__column {
    grid-column: 3;
}
.section-header--renta,
.tax-row.tax-row--renta {
    grid-template-columns: minmax(170px, 0.85fr) repeat(3, minmax(140px, 1fr));
}
.tax-table {
    display: grid;
    gap: 8px;
}
.tax-row {
    display: grid;
    grid-template-columns: minmax(170px, 0.85fr) minmax(210px, 1fr) minmax(210px, 1fr);
    column-gap: 14px;
    align-items: center;
}
.tax-row {
    min-height: 48px;
    padding: 4px 0;
    border-bottom: 1px solid #eef1f5;
}
.tax-row.tax-row--single-value {
    grid-template-columns: minmax(170px, 0.85fr) minmax(210px, 1fr) minmax(210px, 1fr);
}
.tax-row.tax-row--single-value > .tax-cell:not(.tax-cell--description) {
    grid-column: 3;
}
.tax-cell--description {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    color: #374151;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.25;
}
.tax-cell--empty {
    min-height: 40px;
}
.tax-cell--with-icon {
    display: flex;
    align-items: center;
    gap: 6px;
}
.tax-cell--with-icon ::v-deep .v-input {
    flex: 1 1 auto;
    min-width: 0;
}
.calculated-icon {
    color: #64748b;
    flex: 0 0 auto;
}
.payment-fill-btn {
    margin-right: 4px;
}
.tax-cell ::v-deep .v-input {
    margin-top: 0;
}
.tax-cell ::v-deep input {
    text-align: right;
}

@media (max-width: 960px) {
    .section-header {
        grid-template-columns: 1fr auto auto;
        column-gap: 12px;
    }
    .section-header--renta {
        grid-template-columns: 1fr auto auto auto;
    }
    .tax-row {
        grid-template-columns: 1fr;
        gap: 8px;
        align-items: stretch;
        padding: 12px 0;
    }
    .tax-row.tax-row--renta {
        grid-template-columns: 1fr;
    }
    .tax-row.tax-row--single-value {
        grid-template-columns: 1fr;
    }
    .tax-row.tax-row--single-value > .tax-cell:not(.tax-cell--description) {
        grid-column: auto;
    }
    .tax-cell:not(.tax-cell--description):not(.tax-cell--empty)::before {
        content: attr(data-label);
        display: block;
        margin-bottom: 4px;
        color: #6b7280;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
    }
    .tax-cell--description {
        font-size: 14px;
    }
    .tax-cell--empty {
        display: none;
    }
}
</style>
